import { useEffect, useState, useCallback } from "react";
import { Layout } from "../../GlobalComponent/Layout/Layout";
import style from './AddCompanies.module.css';
import TableData from "./components/table";
import AddData from "./components/AddData";
import { getCompany as fetchCompany } from "../../Http/Index";
import { Box, Heading, Tabs, TabList, TabPanels, Tab, TabPanel } from "@chakra-ui/react";
import CompanyIndex from "./CompanyIndex";
import AmbulanceMap from "./AmbulanceMap";
import BeneficiaryMap from "./BeneficiaryMap";
import TicketMap from "./TicketMap";
import { Company } from "../../Interfaces/Company";
import { ChiMisReport } from "./ChiMisReport";

const AddCompany = () => {
  const [companies, setCompanies] = useState<Company[]>([]);
  const [activeTab, setActiveTab] = useState(0);
  const [view, setView] = useState<"list" | "form">("list");
  const [selectedCompany, setSelectedCompany] = useState<Company | null>(null);

  const getCompanyList = useCallback(async () => {
    try {
      const response = await fetchCompany();
      setCompanies(response.data.data);
    } catch (error) {
      console.error("Error fetching company data:", error);
    }
  }, []);


  useEffect(() => {
    getCompanyList();
  }, [getCompanyList]);

  const handleAddClick = () => {
    setSelectedCompany(null);
    setView("form");
  };

  const handleEditClick = (company: Company) => {
    setSelectedCompany(company);
    setView("form");
  };

  const handleClose = () => {
    setView("list");
    setSelectedCompany(null);
  };

  return (
    <Layout>
      <div className={style.main_div}>
        <Tabs defaultIndex={0} onChange={(index) => { setActiveTab(index); setView("list"); setSelectedCompany(null); }}>
          <TabList>
            <Tab>Manage Company</Tab>
            <Tab>Company Index</Tab>
            <Tab>Ambulance Map</Tab>
            <Tab>Ticket Map</Tab>
            <Tab>Beneficiary Map</Tab>
            <Tab>CHI MIS Report</Tab>
          </TabList>

          <TabPanels>
            <TabPanel>
              <Box display="flex" justifyContent="center" mt="10px">
                <Heading size="lg">Manage Company</Heading>
              </Box>
              {view === "list" ? (
                <TableData
                  data={companies}
                  onEdit={handleEditClick}
                  onAddClick={handleAddClick}
                />
              ) : (
                <AddData
                  company={selectedCompany}
                  onClose={handleClose}
                  onSuccess={getCompanyList}
                />
              )}
            </TabPanel>

            <TabPanel>
              <CompanyIndex />
            </TabPanel>

            <TabPanel p={0} mt={"10px"}>
              <AmbulanceMap companies={companies} isActive={activeTab === 2} />
            </TabPanel>

            <TabPanel p={0} mt={"10px"}>
              <TicketMap companies={companies} isActive={activeTab === 3} />
            </TabPanel>

            <TabPanel p={0} mt={"10px"}>
              <BeneficiaryMap companies={companies} isActive={activeTab === 4} />
            </TabPanel>

            <TabPanel p={0} mt={"10px"}>
              {activeTab === 5 && <ChiMisReport />}
            </TabPanel>
          </TabPanels>
        </Tabs>
      </div>
    </Layout>
  );
};

export default AddCompany;
